export default __webpack_public_path__ + "src/assets/whitepaper.e049fe7172874ec4454c15a584b4a5b0.svg";